const MEDIA_ITEMS = [
  {
    title: '深度解析：娱乐圈"塌房"背后的资本博弈',
    duration: '18:24',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20financial%20analysis%20atmosphere%2C%20dark%20background%20with%20warm%20golden%20data%20visualization%20elements%2C%20investigative%20journalism%20vibe%2C%20no%20people%2C%20editorial%20style&width=600&height=400&seq=media-card-01&orientation=landscape',
    tag: '深度',
  },
  {
    title: '吃瓜指南：如何辨别网络爆料的真伪？三招教你理性吃瓜',
    duration: '12:06',
    image: 'https://readdy.ai/api/search-image?query=Educational%20detective%20abstract%20with%20magnifying%20glass%20implied%20shapes%2C%20warm%20investigative%20tone%2C%20soft%20dramatic%20lighting%2C%20truth%20seeking%20atmosphere%2C%20no%20people&width=600&height=400&seq=media-card-02&orientation=landscape',
    tag: '指南',
  },
  {
    title: '年度盘点：今年最让人意外的十大反转事件',
    duration: '25:40',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20twist%20abstract%20composition%2C%20warm%20golden%20and%20crimson%20tones%2C%20dynamic%20shapes%20suggesting%20unexpected%20turn%2C%20cinematic%20atmosphere%2C%20no%20people&width=600&height=400&seq=media-card-03&orientation=landscape',
    tag: '盘点',
  },
  {
    title: '圈内人讲述：我做娱乐记者这十年看到的惊人内幕',
    duration: '32:15',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20newsroom%20abstract%20atmosphere%2C%20warm%20ambient%20backlighting%2C%20journalism%20and%20investigation%20vibe%2C%20dark%20background%20with%20golden%20highlights%2C%20no%20people&width=600&height=400&seq=media-card-04&orientation=landscape',
    tag: '专访',
  },
  {
    title: '热搜背后：一条娱乐八卦是如何被推上热搜的？',
    duration: '15:52',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20social%20media%20algorithm%20visualization%2C%20warm%20vibrant%20data%20flow%20shapes%2C%20trending%20topic%20atmosphere%2C%20dark%20background%20with%20golden%20amber%20accents%2C%20no%20people&width=600&height=400&seq=media-card-05&orientation=landscape',
    tag: '揭秘',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            吃瓜影音
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            深度解读与专题视频，换个姿势继续吃瓜
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {MEDIA_ITEMS.map((item) => (
            <div
              key={item.title}
              className="group rounded-lg bg-background-100 border border-background-200/60 overflow-hidden cursor-pointer hover:border-primary-200 transition-colors"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute top-3 left-3 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 bg-black/60 text-background-50 text-xs rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}